export default __webpack_public_path__ + "static/media/moment.8b8a04f4.png";